import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Container, Card, CardHeader, CardBody } from "reactstrap";
import { createSelector } from 'reselect';
import ExportScript from './PublishTypes/Display/ExportScript';
import PublishDCM from './PublishTypes/Display/PublishDCM';
import { goBack, push, replace } from 'redux-first-history';
import { resetPublishState, setBusinessList, setCatalogId, setCatalogList, setCreativesForPublish, setFbBusinessId, setFbCatalogPublishSettings, setIsBusinessAuthenticated, setPublishList, setPublishLoader, setScriptPublishTag, setSelectedCreativesPublish, setSelectedPublishType, setUserFacebookId, setWhereToPublish } from '../../../slices/publish/reducer';
import Script from '../Display/Script';
import DCM from '../Display/DCM';
import { useLocation, useParams } from 'react-router-dom';
import { getCampaigns, getVersions } from '../../../slices/campaigns/thunk';
import { setBreadcrumb, setCampaignPath } from '../../../slices/auth/menu/reducer';
import { getVersionsSuccess, setCampaignLoader, setConnectedFeed, setConnectedFeedName, setCreatives, setCurrentCampaign, setCurrentVersion, setFacebookCreativeIds, setFacebookId, setFacebookStatus, setFilteredCreatives, setIsFacebookProperties, setProperties } from '../../../slices/campaigns/reducer';
import { getCreativesForPublish, getPublishList, getScriptPublishTag } from '../../../slices/publish/thunk';
import { createGoogleAuth, getDcmProfiles } from '../../../slices/publish/dcm/thunk';
import PublishAdform from './PublishTypes/Display/PublishAdform';
import Adform from '../Display/Adform';
import { getAdformCredential } from '../../../slices/publish/adform/thunk';
import ExportFacebookScript from './PublishTypes/Facebook/ExportFacebookScript';
import PublishFacebookCatalog from './PublishTypes/Facebook/PublishFacebookCatalog.js';
import { default as FacebookScript } from '../Social/Script/index.js';
import { default as FacebookCatalog } from '../Social/Catalog/index.js';
import { createFacebookUserAuth } from '../../../slices/publish/facebook/thunk.js';


function WhereToPublish() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const selectStates = createSelector(state => state, state => ({
    whereToPublish: state.Publish.whereToPublish,
    publishTypes: state.Publish.publishTypes,
    previousLocations: state.router.previousLocations,
    campaigns: state.Campaign.allLibraries,
    currentCampaign: state.Campaign.currentCampaign,
    versions: state.Campaign.versions,
    currentVersion: state.Campaign.currentVersion,
    creatives: state.Campaign.creatives,
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
    facebookProperties: {
      _id: state.Campaign.facebookId,
      properties: {
        id: state.Campaign.id,
        title: state.Campaign.title,
        description: state.Campaign.description,
        availability: state.Campaign.availability,
        condition: state.Campaign.condition,
        price: state.Campaign.price,
        link: state.Campaign.link,
        image_link: state.Campaign.image_link,
      },
      brandId: state.Campaign.brand,
      interval: state.Campaign.interval,
      exportType: 'image',
      limit: state.Campaign.limit,
    },
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    facebookStatus: state.Campaign.facebookStatus,
    facebookCreativeIds: state.Campaign.facebookCreativeIds,
  }));
  const {
    whereToPublish,
    publishTypes,
    previousLocations,
    campaigns,
    currentCampaign,
    versions,
    currentVersion,
    creatives,
    connectedFeed,
    connectedFeedName,
    facebookProperties,
    isFacebookPropertiesSet,
    facebookStatus,
    facebookCreativeIds
  } = useSelector(selectStates);
  const [selectedPublishType, setSelectedPublishTypeState] = useState(null);
  useEffect(() => {
    async function openPublishPage() {
      if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
        dispatch(setPublishLoader(true));
        dispatch(setCampaignPath(params.campaignId));
        const campaignRes = await dispatch(getCampaigns());
        const foundCurrentCampaign = campaignRes.payload.find(campaign => campaign._id === params.campaignId);
        dispatch(setCurrentCampaign(foundCurrentCampaign));
        const versionRes = await dispatch(getVersions());
        if (versionRes.payload.length > 0) {
          dispatch(setCurrentVersion(versionRes.payload[0]));
          const publishListRes = await dispatch(getPublishList());
          const creativesRes = await dispatch(getCreativesForPublish({ value: versionRes.payload[0]._id }));
          dispatch(setWhereToPublish(true));
          dispatch(replace(location.pathname + location.search,
            {
              versions: versionRes.payload,
              currentCampaign: foundCurrentCampaign,
              publishList: publishListRes.payload,
              creatives: creativesRes.payload,
              title: [{ name: foundCurrentCampaign?.name, src: window.location.href.replace('publish', 'campaigns') }],
              whereToPublish: true,
            }
          ))
          dispatch(setPublishLoader(false));
        }
      } else if (previousLocations[0].location.state !== null) {
        dispatch(setPublishLoader(false));
        dispatch(getVersionsSuccess(previousLocations[0].location.state.versions));
        dispatch(setCurrentVersion(previousLocations[0].location.state.currentVersion));
        dispatch(setCurrentCampaign(previousLocations[0].location.state.currentCampaign));
        dispatch(setPublishList(previousLocations[0].location.state.publishList));
        dispatch(setCreatives(previousLocations[0].location.state.creatives));
        // dispatch(setFilteredCreatives(previousLocations[0].location.state.creatives));
        dispatch(setConnectedFeed(previousLocations[0].location.state.connectedFeed));
        dispatch(setConnectedFeedName(previousLocations[0].location.state.connectedFeedName));
        dispatch(setBreadcrumb({ pageTitle: 'Publish', title: previousLocations[0].location.state.title }))
        // if (previousLocations[0].location.state.direction === 'back') {
        //   setSelectedPublishTypeState(null);
        //   dispatch(setSelectedPublishType(null));
        //   dispatch(setWhereToPublish(true))
        // }
        if (previousLocations[0].location.state.facebookProperties && previousLocations[0].location.state.facebookProperties._id) {
          dispatch(setProperties(previousLocations[0].location.state.facebookProperties));
          dispatch(setIsFacebookProperties(previousLocations[0].location.state.isFacebookPropertiesSet));
          dispatch(setFacebookId(previousLocations[0].location.state.facebookProperties._id));
          dispatch(setFacebookStatus(previousLocations[0].location.state.facebookStatus));
          dispatch(setFacebookCreativeIds(previousLocations[0].location.state.facebookCreativeIds));
        }
        setSelectedPublishTypeState(previousLocations[0].location.state.publishType);
        dispatch(setSelectedPublishType(previousLocations[0].location.state.publishType));
        dispatch(setWhereToPublish(previousLocations[0].location.state.whereToPublish));
        dispatch(setUserFacebookId(previousLocations[0].location.state.userFacebookId));
        dispatch(setBusinessList((previousLocations[0].location.state.businessList || [])));
        dispatch(setCatalogList((previousLocations[0].location.state.catalogList || [])));
      }
    }
    openPublishPage();
  }, [previousLocations]);

  useEffect(() => {
    if (location.search && location.search !== '') {
      setSelectedPublishType(location.search.split('=')[1]);
      if (previousLocations[0].location.state === null) {
        let item = { tag: location.search.split('=')[1] }
        // selectPublishType(item);
      } else if (previousLocations[0].location.state !== null) {
        dispatch(getVersionsSuccess(previousLocations[0].location.state.versions));
        dispatch(setCurrentVersion(previousLocations[0].location.state.currentVersion));
        dispatch(setCurrentCampaign(previousLocations[0].location.state.currentCampaign));
        dispatch(setPublishList(previousLocations[0].location.state.publishList));
        dispatch(setCreativesForPublish(previousLocations[0].location.state.creatives));
        dispatch(setSelectedPublishType(previousLocations[0].location.state.publishType));
        setSelectedPublishTypeState(previousLocations[0].location.state.publishType);
        dispatch(setConnectedFeed(previousLocations[0].location.state.connectedFeed));
        dispatch(setConnectedFeedName(previousLocations[0].location.state.connectedFeedName));
        dispatch(setWhereToPublish(previousLocations[0].location.state.whereToPublish));
        if (previousLocations[0].location.state.facebookProperties && previousLocations[0].location.state.facebookProperties._id) {
          dispatch(setProperties(previousLocations[0].location.state.facebookProperties));
          dispatch(setIsFacebookProperties(previousLocations[0].location.state.isFacebookPropertiesSet));
          dispatch(setFacebookId(previousLocations[0].location.state.facebookProperties._id));
          dispatch(setFacebookStatus(previousLocations[0].location.state.facebookStatus));
          dispatch(setFacebookCreativeIds(previousLocations[0].location.state.facebookCreativeIds));
        }
        dispatch(setUserFacebookId(previousLocations[0].location.state.userFacebookId));
        dispatch(setCatalogId(previousLocations[0].location.state.catalogId));
        dispatch(setFbBusinessId(previousLocations[0].location.state.fbBusinessId));
        dispatch(setFbCatalogPublishSettings(previousLocations[0].location.state.fbCatalogPublishSettings));
        dispatch(setSelectedCreativesPublish((previousLocations[0].location.state.selectedCreativesPublish || [])));
        dispatch(setIsBusinessAuthenticated(previousLocations[0].location.state.isBusinessAuthenticated));
      }
    }
  }, [location]);

  async function selectPublishType(item) {
    dispatch(setPublishLoader(true));
    dispatch(setSelectedPublishType(item.tag));
    setSelectedPublishTypeState(item.tag);
    if (item.tag === 'dcm') {
      await dispatch(createGoogleAuth());
    } else if (item.tag === 'adform') {
      await dispatch(getAdformCredential());
    } else if (item.tag === 'facebookCatalog') {
      await dispatch(createFacebookUserAuth());
      dispatch(setPublishLoader(false));
      return;
    }
    dispatch(push(`${location.pathname}?type=${item.tag}`, {
      versions: versions,
      currentVersion: (versions[0] ? versions[0] : null),
      currentCampaign: currentCampaign,
      publishList: publishTypes,
      creatives: (creatives || []).map((item) => {
        let returnObj = {};
        let keys = Object.keys(item);
        keys.forEach(key => {
          if (key !== 'preview') {
            returnObj[key] = item[key];
          }
        });
        return returnObj;
      }),
      publishType: item.tag,
      connectedFeed: connectedFeed,
      connectedFeedName: connectedFeedName,
      whereToPublish: whereToPublish,
      facebookProperties: facebookProperties,
      isFacebookPropertiesSet: isFacebookPropertiesSet,
      facebookStatus: facebookStatus,
      facebookCreativeIds: facebookCreativeIds,
    }));
  }

  function handleGoBack() {
    if (Array.isArray(previousLocations) && previousLocations[previousLocations.length - 1].location.pathname.includes('facebook-authentication')) {
      dispatch(setBreadcrumb({name: 'Ad Library', title: []}));
      dispatch(push(window.location.pathname.replace('publish', 'campaigns'), null));
    } else {
      dispatch(goBack());
    }
  }

  return (
    <React.Fragment>
      {selectedPublishType ?
        selectedPublishType === 'scriptTags' ?
          <Script />
          : selectedPublishType === 'dcm' ?
            <DCM />
            : selectedPublishType === 'adform' ?
              <Adform />
              : selectedPublishType === 'facebookScript' ?
                <FacebookScript />
                : selectedPublishType === 'facebookCatalog' ?
                  <FacebookCatalog /> : null
        :
        whereToPublish ?
          <React.Fragment>
            <Row>
              <Col>
                <Card>
                  <div className='w-100 p-3 d-flex align-items-center'>
                    <button className='btn btn-light btn-icon fw-bold' onClick={handleGoBack}>
                      <i className='ri-arrow-left-line'></i>
                    </button>
                    <p className='ms-2 mb-0'>Where to publish?</p>
                  </div>
                </Card>
              </Col>
            </Row>
            {publishTypes && publishTypes.length > 0 ?
              <Row>
                {publishTypes.map((item, key) => {
                  if (item) {
                    if (item.tag === 'scriptTags') {
                      return (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} key={key}>
                          <ExportScript item={item} onSelect={() => selectPublishType(item)} />
                        </Col>
                      )
                    } else if (item.tag === 'dcm') {
                      return (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} key={key}>
                          <PublishDCM item={item} onSelect={() => selectPublishType(item)} />
                        </Col>
                      )
                    } else if (item.tag === 'adform') {
                      return (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} key={key}>
                          <PublishAdform item={item} onSelect={() => selectPublishType(item)} />
                        </Col>
                      )
                    } else if (item.tag === 'facebookScript') {
                      return (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} key={key}>
                          <ExportFacebookScript item={item} onSelect={() => selectPublishType(item)} />
                        </Col>
                      )
                    } else if (item.tag === 'facebookCatalog') {
                      return (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} key={key}>
                          <PublishFacebookCatalog item={item} onSelect={() => selectPublishType(item)} />
                        </Col>
                      )
                    }
                  }
                })}
              </Row>
              : null}
          </React.Fragment>
          : null}
    </React.Fragment>
  )
}

export default WhereToPublish;
